/**
 * Function for decoding JWT (Json Web Token)
 * which is accessToken, refreshToken, etc...
 */

export default (jwt) => {
  const token = {}
  token.header = JSON.parse(window.atob(jwt.split('.')[0]))
  token.payload = JSON.parse(window.atob(jwt.split('.')[1]))
  return token
}



// WEBPACK FOOTER //
// ./src/utils/decodeJWT.js